<div class="row">
  <div class="col-sm-12 text-center">
      <div class="sign-in-forms">
      <div class="text-center">
          <img src="/assets/images/clapping.gif" width="20%">
      </div>
      <ul class="mt-5 non-style">
          <li>
              <h4 class="text-success"> <i class="fa fa-check-circle text-success"></i> Your account creation has
                  succeeded</h4>
          </li>
          <li>
              <h4> <i class="fa fa-circle-o text-secondary"></i> Now verifying account with code {{vcode}}</h4>
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
              <div class="text-center" *ngIf="!loading">
                <img src="/assets/images/clapping.gif" width="40%">
            </div>
          </li>
      </ul>
    </div>
  </div>
</div>
